;var Preloader = (function() {
  
  var urlList = {};

  var itemsToLoad = 0;
  var onLoadAssets;

  function loadAssets(json, callback) {
    onLoadAssets = callback;

    for (var i = 0; i < json.length; i++) {
      var chapter = json[i];

      // navigation thumb
      loadItem(chapter.img);

      // videos
      if (chapter.video) {
        loadItem(chapter.video.forward);
        loadItem(chapter.video.backward);
        loadItem(chapter.video.loop);
      }

      // sequences
      if (chapter.sequence) {
        for (var j = 0; j < chapter.sequence.frames; j++) {
          var number = fillZero(j+1);
          loadItem('images/sequences/'+chapter.sequence.folder+'/'+number+'.jpg');
        }
      }
    }
  }

  function loadItem(url, type) {
    if (!url) {
      return;
    }

    itemsToLoad++;

    var req = new XMLHttpRequest();
    req.open('GET', ASSETS_FOLDER+url, true);
    req.responseType = 'blob';

    req.onload = function() {
      if (this.status === 200) {
        var blob = this.response;
        var urlLocal = URL.createObjectURL(blob);
        urlList[url] = urlLocal;
      }
      onLoadItem();
    }
    req.onerror = function() {
      onLoadItem();
    }

    req.send();
  }

  function onLoadItem() {
    itemsToLoad--;
    if (!itemsToLoad) {
      onLoadAssets();
    }
  }

  function getUrl(url) {
    return urlList[url] || ASSETS_FOLDER+url;
  }

  return {
    loadAssets: loadAssets,
    getUrl: getUrl,
  }

})();
